import { IKeyValue } from '@fareye/types'
import { isValidDate, formatMs } from '@fareye/utils'
import { colorOption } from '../components/SummaryV2'

export function getYKeys(data: any[]) {
  const allKeys: string[] = []
  data.map(item => allKeys.push(...Object.keys(item)))
  return Array.from(new Set(allKeys)).filter(key => key !== 'label')
}

export function filterSearchParam(obj: IKeyValue<any>) {
  return Object.entries(obj).reduce(
    (selectedList: IKeyValue<string>[], [key, value]) => {
      if (!isValidDate(new Date(value))) {
        let tempObj = { label: value, key, value }
        selectedList.push(tempObj)
      }
      return selectedList
    },
    []
  )
}

export function getRunningStatusObj(val: number) {
  let statusObj = { label: '', labelStatus: '', style: {} }
  if (!val && val !== 0) return null
  else {
    if (val > 0) {
      statusObj = {
        label: formatMs(val),
        labelStatus: 'Delayed',
        style: { color: colorOption.delayed }
      }
    } else if (val === 0) {
      statusObj = {
        label: 'Ontime',
        labelStatus: '\u00a0',
        style: { color: colorOption.on_time }
      }
    } else {
      statusObj = {
        label: formatMs(val),
        labelStatus: 'Early',
        style: { color: colorOption.early }
      }
    }
    return statusObj
  }
}

export function extraInfoForStop(stop: any, fillOptions = colorOption) {
  const appointmentTime = stop.appointmentWindowInMins
    ? stop.appointmentWindowInMins * 60 * 1000
    : 0
  const etaTime = new Date(stop.eta.time).getTime()
  const staTime = new Date(stop.sta.time).getTime()
  if (etaTime >= staTime + appointmentTime) {
    return { text: 'Delayed', fill: fillOptions.delayed }
  } else if (etaTime < staTime) {
    return { text: 'Early', fill: fillOptions.early }
  } else {
    return { text: 'Ontime', fill: fillOptions.on_time }
  }
}

export function standardizeText(text: String) {
  return text ? text.toLowerCase().replace(' ', '_') : text
}

export function cToF(celsius: number) {
  const cTemp = celsius
  const cToFahr = (cTemp * 9) / 5 + 32
  return cToFahr
}

export function fToC(fahrenheit: number) {
  const fTemp = fahrenheit
  const fToCel = ((fTemp - 32) * 5) / 9
  return fToCel
}